const isNumber = {
    name: "is-number",
    validate: (v) => !isNaN(v),
};
exports.isNumber = isNumber;
